import { CATEGORIES } from "~/components/faq/constants"

import WinitFadeLogo from "../../public/static/images/png/knowledge-base/winit-fade-logo.png"
import TicketSearch from "../../public/static/images/png/knowledge-base/ticket-search.png"
import License from "../../public/static/images/png/knowledge-base/license.png"
import TicketsFlying from "../../public/static/images/png/knowledge-base/tickets-flying.png"
import LicenseFemale from "../../public/static/images/png/knowledge-base/license-female.png"


export default [
  {
    title: "Can WinIt Fight My Ticket?",
    type: [CATEGORIES.parking, CATEGORIES.traffic],
    icon: WinitFadeLogo,
    // icon: "/assets/png/winit-fade-logo.png",
    // image: '/assets/home/city/hero-3x.png',
    date: "2018-09-07T17:34:56+00:00",
    suggested: [
      "NYC Parking Tickets vs NYC Traffic Tickets",
      "How do traffic tickets work in NYC?",
      "What kind of evidence is the most effective?"
    ],
    content: `If you received an NYC parking ticket, fight it risk-free by submitting it in the WinIt app. Our team of specialists will dispute your ticket on your behalf! If your ticket is dismissed, WinIt’s fee is only HALF of the original fine. If we don’t win, we’ll notify you so you can pay your parking ticket without any penalties.

If you opened your mail and got a camera moving violation like a Red Light Camera violation or a School Zone speeding ticket, WinIt can help by enabling you to pay the fine with one touch, in the app.

If you were pulled over and given a traffic ticket, you can use WinIt to hire an experienced traffic attorney.`
  },
  {
    title: "How are tickets assigned?",
    type: [CATEGORIES.parking, CATEGORIES.traffic],
    icon: TicketSearch,
    // image: '/assets/home/city/hero-3x.png',
    date: "2018-09-07T17:34:56+00:00",
    suggested: [
      "Can WinIt Fight My Ticket?",
      "How do traffic tickets work in NYC?",
      "What kind of evidence is the most effective?"
    ],
    content: `Traffic tickets are issued to the driver’s license of the individual behind the wheel at the time of the violation. This means that regardless of who owns the car, the liability will typically fall to the person who actually committed the infraction.

There’s one exception to this rule, and that’s for camera moving violations, which are sent by mail along with the photo from the traffic camera. These tickets are usually treated like parking tickets, meaning that the responsibility to dispute or pay the fine rests with the registered owner of the vehicle and license plate.`
  },
  {
    title: "How do traffic tickets work?",
    type: [CATEGORIES.traffic],
    icon: License,
    // image: '/assets/home/city/hero-3x.png',
    date: "2018-09-07T17:34:56+00:00",
    suggested: [
      "NYC Parking Tickets vs NYC Traffic Tickets",
      "How are tickets assigned?",
      "How do points work in New York?"
    ],
    content: `Traffic fines in New York and other costs associated will depend on various factors, such as:

- Type of violation.
- Number of points on your driving record.
- Court handling your case
- County where you received the ticket.

If your ticket doesn’t list the fine, it may provide you with steps for calculating it yourself. Because the fine amount is sometimes affected by your driving history, your lawyer cannot always help you determine the fine until you’ve hired them to represent you.`
  },
  {
    title: "How do points work in New York?",
    type: [CATEGORIES.traffic],
    icon: TicketsFlying,
    // image: '/assets/home/city/hero-3x.png',
    date: "2018-09-07T17:34:56+00:00",
    suggested: [
      "When should I hire a traffic lawyer?",
      "Will my license be suspended?",
      "The Real Cost of Paying A Traffic Ticket"
    ],
    content: `If you are found guilty of a traffic moving violation in NY, or if you fight the ticket, lose, and have to pay the traffic ticket fine, you may also have points added to your driver’s license. More severe violations will add more points.

If you accumulate 6 points or more within 18 months, the city may require that you pay what’s called a Driver Responsibility Assessment Fee. Depending on the type of violations you’ve been found guilty of, you may also be responsible for other penalties, including being required to take a driver safety class.

If you accumulate 11 points or more within 18 months, your license may be suspended. At this point, the suspension may be indefinite, and the specifics of your fines and penalties are left up to the court. Points incurred for a particular violation may remain on your record after 18 months, but will no longer count towards this total.

Regardless of how many points you have on your record, your license may be immediately suspended or revoked for any of these violations:

- Driving while intoxicated or under the influence of drugs
- Failure to pay outstanding traffic fines
- Failure to file motor vehicle accident reports
- Unpaid taxes
- Failure to maintain auto liability insurance
- Being involved in a motor vehicle collision resulting in a fatality

In addition to automatic suspension if you accumulate more than 11 points in 18 months, there are several reasons why your license might be immediately suspended after a new violation, regardless of how many points you have on your record.

If you are found guilty of 3 speeding violations within 18 months, your driver’s license may be revoked for at least six months.

If you are found guilty of 3 misdemeanor traffic violations within 18 months, this may also result in your license being suspended or revoked for at least six months.

If you passed your road test less than six months ago, it only takes 2 moving violations to result in a suspended license.

If you are found guilty of texting or using your cell phone, your license may be automatically suspended for 120 days.`
  },
  {
    title: "Will my license be suspended?",
    type: [CATEGORIES.parking, CATEGORIES.traffic],
    icon: LicenseFemale,
    // image: '/assets/home/city/hero-3x.png',
    date: "2018-09-07T17:34:56+00:00",
    suggested: [
      "When should I hire a traffic lawyer?",
      "How do points work in New York?",
      "The Real Cost of Paying A Traffic Ticket "
    ],
    content: `In addition to automatic suspension if you accumulate more than 11 points in 18 months, there are several reasons why your license might be immediately suspended after a new violation, regardless of how many points you have on your record.

If you are found guilty of 3 speeding violations within 18 months, your driver’s license may be revoked for at least six months.

If you are found guilty of 3 misdemeanor traffic violations within 18 months, this may also result in your license being suspended or revoked for at least six months.

If you passed your road test less than six months ago, it only takes 2 moving violations to result in a suspended license.

If you are found guilty of texting or using your cell phone, your license may be automatically suspended for 120 days.

Other reasons your license may be summarily suspended, regardless of your points, include:

- Driving while intoxicated or under the influence of drugs
- Failure to pay outstanding traffic fines
- Failure to file motor vehicle accident reports
- Unpaid taxes
- Failure to maintain auto liability insurance
- Being involved in a motor vehicle collision resulting in a fatality`
  },
  // {
  //   title: '',
  //   type: ['parking','traffic'],
  //   icon: '/assets/png/winit-fade-logo.png',
  //   // image: '/assets/home/city/hero-3x.png',
  //   date: '2018-09-07T17:34:56+00:00',
  //   suggested: [
  //     '',
  //     '',
  //     '',
  //   ],
  //   content: ``
  // },
]
